"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.goal", {
      url: "goal",
      resolve: {
        list: [
          "$stateParams",
          "Goal",
          function ($stateParams, Goal) {
            return Goal.list().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/SWFlow/goal/views/goal.list.html",
          controller: "goalListCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.goal-edit", {
      url: "goal/:id",
      resolve: {
        model: [
          "$stateParams",
          "Goal",
          function ($stateParams, Goal) {
            if ($stateParams.id) {
              return Goal.get({ id: $stateParams.id }).$promise;
            }

            return {};
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/SWFlow/goal/views/goal.edit.html",
          controller: "goalEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
